import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { LoginComponent } from './users/login.component';
// import { FillComponent } from './users/fill.component';
// import { SignupComponent } from './users/signup.component';
// import { HomeComponent } from './users/home.component';
// import { CompaignComponent } from './advertiser/compaign/compaign.component';
// import { AdvertiserComponent } from './advertiser/advertiser.component';
// import { AdSignupComponent } from './advertiser/ad-signup.component';
// import { AdLoginComponent } from './advertiser/ad-login.component';
// import { ProfileComponent } from './advertiser/user-profile.component';
// import { CreateCompaignComponent } from './advertiser/compaign/createcompaign.component';
// import { InterestComponent } from './users/interest.component';
// import { ResetrpasswordComponent } from './advertiser/resetpassword.component';
// import { UserResetrpasswordComponent } from './users/resetpassword.component';
// import { WallComponent } from './users/wall/wall.component';
// import { WallNotificationComponent } from './users/wall/wall.notification.component';
// import { AccountComponent } from './users/account/account.component';
// import { CustomizeSegmentComponent } from './users/customize-segment.component';
// import { TermsComponent } from './users/terms.component';
// import { PrivacyComponent } from './users/privacy.component';
// import { adPrivacyComponent } from './advertiser/privacy.component';
// import { HowToDocumentComponent } from './advertiser/how-to-document.component';

// import { adTermsComponent } from './advertiser/terms.component';
// import { LocationComponent } from './users/location.component';
// import { UpdatepasswordComponent } from './users/account/updatepassword.component';
// import { DeleteuseraccountComponent } from './users/account/deleteuseraccount.component';
 import { AuthGuard } from './guards/auth.guard.component';
 import { AuthGuardRoute } from './guards/auth.guard.route.component';
// import { ResetconfirmComponent } from './users/resetconfirm.component';
// import { PopupReportComponent } from './users/popup/popup-report.component';
// import { PopupDetailComponent } from './users/popup/popup-detail.component';
// import { LocaldbComponent } from './localdb/localdb.component';

// import { AddResetconfirmComponent } from './advertiser/resetconfirm.component';

// import { AdlandingComponent } from './advertiser/adlanding.component';
// import { AdaccountComponent } from './advertiser/adaccount/adaccount.component';
// import { CampaignListComponent } from './advertiser/campaign-list/campaign-list.component';
// import { DraftCampaignComponent } from './advertiser/campaign-list/draftcampaign.component';
// import { ViewCampaignComponent } from './advertiser/campaign-list/viewcampaign.component';
import { payreceiptComponent } from './advertiser/compaign/payreceipt.component';
// import { SettingsComponent } from './users/account/settings.component';


import { AdminLoginComponent } from './admin/login/login.component';
import { AdminResetconfirmComponent } from './admin/resetConfirm/resetconfirm.component';
import { ResetpasswordComponent } from './admin/resetPassword/resetpassword.component';
import { UpdatePasswordComponent } from './admin/updatepassword/updatepassword.component';
import { SettingsComponent } from './admin/settings/settings.component';
import { LayoutComponent } from './admin/layout/layout.component';
import { UsersComponent } from './admin/layout/users/users.component';
import { ActiveAdvertisementsComponent } from './admin/layout/activeadvertisements/activeadvertisements.component';
import { AdvertisersComponent } from './admin/layout/advertisers/advertisers.component';
import { AdminWallComponent } from './admin/layout/advertisers/wall.component';
import { CompanyDetailsComponent } from './admin/layout/companyDetails/companyDetails.component';
import { KeywordsComponent } from './admin/layout/keywords/keywords.component';
import { PhrasesComponent } from './admin/layout/phrases/phrases.component';
import { TransactionsComponent } from './admin/layout/transactions/transactions.component';
import { CouponCodeComponent } from './admin/layout/couponCode/couponcode.component';
import { CreateCouponCodeComponent } from './admin/layout/couponCode/createcouponcode.component';
import { TargetAudienceCouponCodeComponent } from './admin/layout/couponCode/targetaudcouponcode.component';
import { BranchCompanyComponent } from './admin/layout/couponCode/branchcompany.component';
import { CompanyInfoComponent } from './admin/layout/couponCode/companyinfo.component';
import { BranchInfoComponent } from './admin/layout/couponCode/branchinfo.component';
import { BasePriceStatesComponent } from './admin/layout/pricingdetails/basepriceStates.component';
import { BasePriceUsersComponent } from './admin/layout/pricingdetails/basepriceUsers.component';
import { PriceGroupComponent } from './admin/layout/pricingdetails/pricegroup.component';
import { ReportedContentComponent } from './admin/layout/reportedContent/reportedcontent.component';
import { UsersReportedListComponent } from './admin/layout/reportedContent/userreportedlist.component';
import { SegmentsComponent } from './admin/layout/segments/segments.component';
import { CreateSegmentsComponent } from './admin/layout/updateCreateSegments/Createsegments.component';
import { UpdateSegmentsComponent } from './admin/layout/updateCreateSegments/Updatesegments.component';
import { AdvertiserUploadComponent } from './admin/layout/advertiserUpload/advertiserUpload.component';
import { PaymentComponent } from './admin/layout/payment/payment.component';


// import { LandingComponent } from './users/landing.component';
export const routes: Routes = [
  { 
    path: '',
    redirectTo: 'users',
    pathMatch : 'full'
  },
  { 
    path: 'advertiser',
    redirectTo: 'advertiser',
    pathMatch : 'full'
  },
  { 
    path: 'howto', 
    loadChildren: './advertiser/how-to-document/how-to-document.module#HowToDocumentModule'
  },
  { 
    path: 'terms',
    loadChildren: './users/terms/terms.module#TermsModule'
  },
  { 
    path: 'privacy',
    loadChildren: './users/privacy/privacy.module#PrivacyModule'
  },
  { 
     path: 'about-us', 
     loadChildren: './users/aboutus/aboutus.module#AboutusModule' 
   },
  
//   { path: '', component: LandingComponent },
//   { path: 'users/login', component: LoginComponent },
//   { path: 'users/signup', component: SignupComponent },
//   { path: 'users/home', component: HomeComponent },
//   { path: 'advertiser/home', component: AdlandingComponent },
//   { path: 'advertiser/landing', component: AdlandingComponent },
//   { path: 'advertiser/compaign', component: CompaignComponent },
//   { path: 'advertiser', component: AdvertiserComponent },
//   { path: 'advertiser/adsignup', component: AdSignupComponent },
//   { path: 'advertiser/adlogin', component: AdLoginComponent },
//   { path: 'advertiser/userprofile', component: ProfileComponent,  canActivate: [AuthGuard] },
//   { path: 'advertiser/createcampaign', component: CreateCompaignComponent , canActivate: [AuthGuard]},
//   { path: 'advertiser/campaignlist', component: CampaignListComponent ,canActivate: [AuthGuard] },
//   { path: 'advertiser/draftcampaign', component: DraftCampaignComponent ,canActivate: [AuthGuard] },
//   { path: 'advertiser/viewcampaign/:id', component: ViewCampaignComponent ,canActivate: [AuthGuard] },
//   { path: 'advertiser/account', component: AdaccountComponent ,  canActivate: [AuthGuard]},
//   { path: 'advertiser/account/:payment', component: AdaccountComponent ,  canActivate: [AuthGuard]},
//   { path: 'users/interest', component: InterestComponent },
//   { path: 'advertiser/resetpassword', component: ResetrpasswordComponent },
//   { path: 'users/resetpassword', component: UserResetrpasswordComponent },
//   { path: 'users/wall', component: WallComponent,  canActivate: [AuthGuard] },
//   { path: 'users/userdetail', component: AccountComponent, canActivate: [AuthGuard] },
//   { path: 'users/customizesegment', component: CustomizeSegmentComponent, canActivate: [AuthGuard] },
//   { path: 'advertiser/terms', component: adTermsComponent },
//   { path: 'advertiser/privacy', component: adPrivacyComponent },
  

//   { path: 'users/terms', component: TermsComponent },
//   { path: 'users/privacy', component: PrivacyComponent },
//   { path: 'terms', component: TermsComponent },
//   { path: 'privacy', component: PrivacyComponent },
//   { path: 'howtodocument', component: HowToDocumentComponent },

//   { path: 'users/location', component: LocationComponent },
//   { path: 'users/updatepassword', component: UpdatepasswordComponent , canActivate: [AuthGuard]},
//   { path: 'users/deleteaccount', component: DeleteuseraccountComponent, canActivate: [AuthGuard] },
//   { path: 'users/resetconfirm/:key', component: ResetconfirmComponent },
//   { path: 'advertiser/resetconfirm/:key', component: AddResetconfirmComponent },
//   { path: 'users/wall/:search', component: WallComponent, canActivate: [AuthGuard] },
//   { path: 'users/wallnotification/:key', component: WallNotificationComponent, canActivate: [AuthGuard] },
//   { path: 'users/popup/popupshow', component: PopupReportComponent},
//     { path: 'users/popup/popupDetailshow', component: PopupDetailComponent },
//   { path: 'localdb/example', component: LocaldbComponent },
//   { path: 'users/fill', component: FillComponent },
  { path: 'advertiser/payreceipt', component: payreceiptComponent, canActivate: [AuthGuard] },
//   { path: 'users/settings', component: SettingsComponent, canActivate: [AuthGuard] },



    { path: 'admin/users', component: UsersComponent, canActivate: [AuthGuard] },
    { path:'admin/login', component:AdminLoginComponent},
    { path: 'admin/resetpassword', component:ResetpasswordComponent },
    { path: 'admin/resetconfirm/:key', component:AdminResetconfirmComponent },
    { path: 'admin/updatepassword', component: UpdatePasswordComponent,canActivate: [AuthGuard] },
    { path: 'admin/settings', component: SettingsComponent,canActivate: [AuthGuard] },
    { path: 'admin/activeAdvertisements', component: ActiveAdvertisementsComponent,canActivate: [AuthGuard]},
    { path: 'admin/activeAdvertisements/:aid', component: ActiveAdvertisementsComponent,canActivate: [AuthGuard]},
    { path: 'admin/advertisers', component: AdvertisersComponent,canActivate: [AuthGuard] },
    { path: 'admin/advertisers/activeAdvertisement', component: AdminWallComponent,canActivate: [AuthGuard]},
    { path: 'admin/companyDetails', component: CompanyDetailsComponent,canActivate: [AuthGuard]},
    { path: 'admin/advertiserUpload', component: AdvertiserUploadComponent,canActivate: [AuthGuard]},
    { path: 'admin/keywords', component: KeywordsComponent,canActivate: [AuthGuard]},
    { path: 'admin/phrases', component: PhrasesComponent,canActivate: [AuthGuard]},
    { path: 'admin/transaction', component: TransactionsComponent,canActivate: [AuthGuard]},
    { path: 'admin/couponCodes', component: CouponCodeComponent },
    { path: 'admin/couponCodes/createCoupon', component: CreateCouponCodeComponent },
    { path: 'admin/couponCodes/audience', component: TargetAudienceCouponCodeComponent },
    { path: 'admin/couponCodes/branches', component: BranchCompanyComponent },
    { path: 'admin/couponCodes/companyInfo', component: CompanyInfoComponent },
    { path: 'admin/couponCodes/branchInfo', component: BranchInfoComponent },
    { path: 'admin/prices/users',component:BasePriceUsersComponent },
    { path: 'admin/prices/state', component: BasePriceStatesComponent },
    { path: 'admin/prices/pricegroup', component:PriceGroupComponent },
    { path: 'admin/reportedcontent', component: ReportedContentComponent },
    { path: 'admin/reportedcontent/usersreported', component: UsersReportedListComponent },
    { path: 'admin/segments', component: SegmentsComponent },
    {path:'admin/segments/updatesegments',component:UpdateSegmentsComponent},
    {path:'admin/segments/createsegments',component:CreateSegmentsComponent},
    {path:'admin/payment',component:PaymentComponent},
    ];

//export const routing: ModuleWithProviders = RouterModule.forRoot(routes);
 export const routing: ModuleWithProviders = RouterModule.forRoot(routes,{ useHash: true });



// WEBPACK FOOTER //
// ./src/app/app.route.ts